import type { Square } from './types.js';

/** Ряд поля: 0..7 (0 = ряд «1» со стороны белых). */
export function rowOf(sq: Square): number {
  return sq >> 2;
}

/** Столбец поля: 0..7 (0 = «a»). */
export function colOf(sq: Square): number {
  const r = sq >> 2;
  const k = sq & 3;
  // тёмные поля ряда r: столбцы чётности r % 2 === 0 ? чётные : нечётные
  return r % 2 === 0 ? k * 2 : k * 2 + 1;
}

/** Индекс тёмного поля по (col,row) или -1, если поле светлое/вне доски. */
export function sqAt(col: number, row: number): Square | -1 {
  if (col < 0 || col > 7 || row < 0 || row > 7) return -1;
  if ((col + row) % 2 !== 0) return -1; // светлое
  return row * 4 + (col >> 1);
}

/** «c3» → индекс. Бросает на светлом/некорректном поле. */
export function algToSq(alg: string): Square {
  const col = alg.charCodeAt(0) - 97;
  const row = Number(alg[1]) - 1;
  const sq = sqAt(col, row);
  if (sq < 0) throw new Error(`not a dark square: ${alg}`);
  return sq;
}

/** Индекс → «c3». */
export function sqToAlg(sq: Square): string {
  return String.fromCharCode(97 + colOf(sq)) + String(rowOf(sq) + 1);
}
